import _ from '../utils/lodash.util';

export default {
  props: ['value'], // Enables v-model for BVModal base element

  data() {
    return {
      errors: [],
      countries: []
    };
  },

  async mounted() {
    try {
      const response = await this.$http.get('/countries');

      this.countries = response.data;
    } catch (err) {
      console.log('Error occurred when trying to get country list.\n' + err);
    }
  },

  methods: {
    toggleCollapse(controlName) {
      this.uiControls[controlName] = !this.uiControls[controlName];
    },

    openAllFilters() {
      for (let control in this.uiControls) {
        this.uiControls[control] = true;
      }
    },

    hideAllFilters() {
      for (let control in this.uiControls) {
        this.uiControls[control] = false;
      }
    },

    runSearch() {
      const filters = _.removeEmptyValues(this.form); // Omit filters that are empty
      this.$emit('filtersSubmitted', filters);
    }
  }
};
